export enum StorageKeys {
  SESSION_KEY = 'session_key',
  IS_SUCCESS = 'is_success',
}

export enum RegisterType {
  createAccount = 'createAccount',
  createManagerAccount = 'createManagerAccount',
  requestDemo = 'requestDemo',
}
